export default __webpack_public_path__ + "static/media/on-prem-logo.d8eef1f1.svg";